import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import SearchUI from '../../widgets/input/SearchUI'
import AvatarUI from '../../widgets/output/AvatarUI'
import LRTableBodyUI from '../../widgets/layout/LRTableBodyUI'
import LRTableActionsUI from '../../widgets/layout/LRTableActionsUI'
import LRTableRowUI from '../../widgets/layout/LRTableRowUI'
import SelectSingleSF from '../../widgets/input/SelectSingleSF'
import IconButtonUI from '../../widgets/action/IconButtonUI'
import IconButtonLinkUI from '../../widgets/action/IconButtonLinkUI'
import EmailUpdateSF from './EmailUpdateSF'
// import './AccountUserDetail.css'

const AccountUserDetailUI = ({context, messageList, accountUser}) =>
  <div className='c_acc_user'>
    <CardUI>
      <div>{accountUser.name}</div>
    </CardUI>

    <EmailUpdateSF context={context} messageList={messageList} email={accountUser.email} />
  </div>


export default AccountUserDetailUI
